// Состояние матч-центра, которое переживает уход на экран матча и возврат BackButton (экран размонтируется маршрутом
// /match/:id): выбранный день, раскрытые страны (по дням), позиция прокрутки. LIVE и открытый календарь — в
// src/ui/headerState.ts (кнопки рисует шапка оболочки). Живёт до перезапуска Mini App.
import { useSyncExternalStore } from 'react';

export interface MatchCenterState {
  /** выбранный день «YYYY-MM-DD»; null — сегодня (сегодня меняется в полночь — экран узнаёт об этом сам) */
  date: string | null;
  /** тапы по странам: день → ключ секции → раскрыта */
  toggled: Record<string, Record<string, boolean>>;
}

let state: MatchCenterState = { date: null, toggled: {} };
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

export const getMatchCenterState = () => state;
export function useMatchCenterState(): MatchCenterState {
  return useSyncExternalStore((cb) => { listeners.add(cb); return () => { listeners.delete(cb); }; }, getMatchCenterState, getMatchCenterState);
}

export function selectDay(date: string | null): void {
  if (state.date === date) return;
  state = { ...state, date };
  scroll = null;
  emit();
}

export function toggleSection(date: string, key: string, expanded: boolean): void {
  state = { ...state, toggled: { ...state.toggled, [date]: { ...state.toggled[date], [key]: expanded } } };
  emit();
}

/** Прокрутка окна на дне: пишет экран, пока смонтирован; читает при возврате. */
let scroll: { date: string; y: number } | null = null;
export const saveScroll = (date: string, y: number) => { scroll = { date, y }; };
export const savedScroll = (date: string): number | null => (scroll?.date === date ? scroll.y : null);

/** Тесты: начальное состояние. */
export function resetMatchCenterState(): void {
  state = { date: null, toggled: {} };
  scroll = null;
  emit();
}
